<div class="row equal-height-row spacing-30">
  <div class="col-lg-6 col-12">
    <div class="card h-100">
      <div class="card-header cursor-pointer align-items-center">
        <div class="card-title m-0">
          <h3 class="fw-bold m-0">{{ 'manageEvent.overview.eventDetails' | translate }}</h3>
        </div>
        <div class="d-flex gap-2">
          <app-button
            [label]="'manageEvent.overview.editEvent' | translate"
            [variant]="'primary'"
            [iconClass]="'fa fa-edit'"
            (clicked)="openEditEventModal()"
          />
        </div>
      </div>
      <div class="card-body p-9">
        <div class="row mb-7">
          <label class="col-lg-4 fw-semibold text-muted">{{ 'manageEvent.overview.eventName' | translate }}</label>
          <div class="col-lg-8">
            <span class="fw-bold fs-6 text-gray-800">{{ event.event_name }}</span>
          </div>
        </div>
        <div class="row mb-7">
          <label class="col-lg-4 fw-semibold text-muted">{{ 'manageEvent.overview.eventType' | translate }}</label>
          <div class="col-lg-8 fv-row">
            <span class="fw-semibold text-gray-800 fs-6">{{ event.event_type?.event_type_name }}</span>
          </div>
        </div>
        <div class="row mb-7">
          <label class="col-lg-4 fw-semibold text-muted">{{ 'manageEvent.overview.registrationDeadline' | translate }}</label>
          <div class="col-lg-8 d-flex align-items-center">
            <span class="fw-semibold fs-6 text-gray-800 me-2">{{ formatTimeDMYHHMM(event.registration_deadline!) }}</span>
          </div>
        </div>
        <div class="row mb-7">
          <label class="col-lg-4 fw-semibold text-muted">{{ 'manageEvent.overview.startDate' | translate }}</label>
          <div class="col-lg-8 d-flex align-items-center">
            <span class="fw-semibold fs-6 text-gray-800 me-2">{{ formatTimeDMYHHMM(event.start_date!) }}</span>
          </div>
        </div>
        <div class="row mb-7">
          <label class="col-lg-4 fw-semibold text-muted">{{ 'manageEvent.overview.endDate' | translate }}</label>
          <div class="col-lg-8 d-flex align-items-center">
            <span class="fw-semibold fs-6 text-gray-800 me-2">{{ formatTimeDMYHHMM(event.end_date!) }}</span>
          </div>
        </div>
        <div class="row mb-7">
          <label class="col-lg-4 fw-semibold text-muted">{{ 'manageEvent.overview.address' | translate }}</label>
          <div class="col-lg-8">
            <a href="#" class="fw-semibold fs-6 text-gray-800 text-hover-primary">{{event.address}}, {{event.postal_code}} {{event.city}}, {{event.country}}</a>
          </div>
        </div>
        @if (event.status !== 'published') {
          <div class="notice d-flex bg-light-warning rounded border-warning border border-dashed p-6">
            <i class="ki-duotone ki-information fs-2tx text-warning me-4">
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
            </i>
            <div class="d-flex flex-stack flex-grow-1">
              <div class="fw-semibold">
                <h4 class="text-gray-900 fw-bold">{{ 'manageEvent.overview.attentionTitle' | translate }}</h4>
                <div class="fs-6 text-gray-700">{{ 'manageEvent.overview.attentionMessage' | translate }}</div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="col-lg-6 col-12">
    <div class="card h-100">
      <div class="card-header cursor-pointer">
        <div class="card-title m-0">
          <h3 class="fw-bold m-0">{{ 'manageEvent.overview.eventDescription' | translate }}</h3>
        </div>
      </div>
      <div class="card-body p-9" style="max-height: 300px; overflow-y: auto;">
        <div [innerHTML]="event.event_description"></div>
      </div>
    </div>
  </div>
</div>
<!-- Stats Cards Row -->
<div class="row g-5 g-xl-10 mb-5 mb-xl-10">
  <!-- Net Earnings Card (After Fees) -->
  <div class="col-xl-3 col-md-6">
    <div class="card card-flush h-100">
      <div class="card-body d-flex flex-column justify-content-between">
        <div class="d-flex align-items-center">
          <div class="symbol symbol-50px me-5">
            <span class="symbol-label" [ngClass]="getNetEarningsAfterFees() >= 0 ? 'bg-light-success' : 'bg-light-danger'">
              <i class="fa fa-chart-line fs-2" [ngClass]="getNetEarningsAfterFees() >= 0 ? 'text-success' : 'text-danger'"></i>
            </span>
          </div>
          <div>
            <span class="text-gray-500 fw-semibold d-block fs-7">{{ 'manageEvent.overview.netEarnings' | translate }}</span>
            <span class="fw-bold d-block fs-2" [ngClass]="getNetEarningsAfterFees() >= 0 ? 'text-success' : 'text-danger'">
              {{ getNetEarningsAfterFees() | number:'1.0-0' }} {{ getDefaultCurrency() }}
            </span>
          </div>
        </div>
        <div class="d-flex align-items-center mt-4">
          <span class="badge fs-7" [ngClass]="getNetEarningsAfterFees() >= 0 ? 'badge-light-success' : 'badge-light-danger'">
            {{ 'manageEvent.overview.afterExpenses' | translate }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Total Revenue Card -->
  <div class="col-xl-3 col-md-6">
    <div class="card card-flush h-100">
      <div class="card-body d-flex flex-column justify-content-between">
        <div class="d-flex align-items-center">
          <div class="symbol symbol-50px me-5">
            <span class="symbol-label bg-light-success">
              <i class="fa fa-coins text-success fs-2"></i>
            </span>
          </div>
          <div>
            <span class="text-gray-500 fw-semibold d-block fs-7">{{ 'manageEvent.overview.totalRevenue' | translate }}</span>
            <span class="text-gray-800 fw-bold d-block fs-2">{{ getTotalNetRevenue() | number:'1.0-0' }} {{ getDefaultCurrency() }}</span>
          </div>
        </div>
        <div class="d-flex align-items-center mt-4">
          <span class="badge badge-light-success fs-7">{{ 'manageEvent.overview.revenueBreakdown' | translate }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Total Expenses Card -->
  <div class="col-xl-3 col-md-6">
    <div class="card card-flush h-100">
      <div class="card-body d-flex flex-column justify-content-between">
        <div class="d-flex align-items-center">
          <div class="symbol symbol-50px me-5">
            <span class="symbol-label bg-light-warning">
              <i class="fa fa-receipt text-warning fs-2"></i>
            </span>
          </div>
          <div>
            <span class="text-gray-500 fw-semibold d-block fs-7">{{ 'manageEvent.overview.totalExpenses' | translate }}</span>
            <span class="text-gray-800 fw-bold d-block fs-2">{{ getTotalExpenses() | number:'1.0-0' }} {{ getDefaultCurrency() }}</span>
          </div>
        </div>
        <div class="d-flex align-items-center mt-4">
          <span class="badge badge-light-warning fs-7">{{ eventExpenses.length }} {{ 'manageEvent.overview.expenses' | translate }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Registrations Card -->
  <div class="col-xl-3 col-md-6">
    <div class="card card-flush h-100">
      <div class="card-body d-flex flex-column justify-content-between">
        <div class="d-flex align-items-center">
          <div class="symbol symbol-50px me-5">
            <span class="symbol-label bg-light-info">
              <i class="fa fa-users text-info fs-2"></i>
            </span>
          </div>
          <div>
            <span class="text-gray-500 fw-semibold d-block fs-7">{{ 'manageEvent.overview.totalRegistrations' | translate }}</span>
            <span class="text-gray-800 fw-bold d-block fs-2">{{ getTotalClassRegistrations() + getTotalServiceRegistrations() + getTotalPackageRegistrations() }}</span>
          </div>
        </div>
        <div class="d-flex align-items-center mt-4">
          <span class="text-gray-500 fs-7">{{ getTotalClassRegistrations() }} {{ 'manageEvent.overview.classesLabel' | translate }}, {{ getTotalServiceRegistrations() }} {{ 'manageEvent.overview.servicesLabel' | translate }}, {{ getTotalPackageRegistrations() }} {{ 'manageEvent.overview.packagesLabel' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Class/Package Registrations Detail -->
<div class="row gy-5 g-xl-10">
  <!-- Package Registrations (for training events) -->
  @if (trainingPackages.length > 0) {
    <div class="col-xl-6 mb-xl-10">
      <div class="card card-flush h-lg-100">
        <div class="card-header flex-nowrap pt-5">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label fw-bold text-gray-900">{{ 'manageEvent.overview.packageRegistrations' | translate }}</span>
            <span class="text-gray-500 pt-2 fw-semibold fs-6">{{ getTotalPackageRegistrations() }} {{ 'manageEvent.overview.totalRegistrationsAcross' | translate }} {{ trainingPackages.length }} {{ 'manageEvent.overview.packagesLabel' | translate }}</span>
          </h3>
        </div>
        <div class="card-body pt-5">
          <div class="hover-scroll-overlay-y pe-6 me-n6" style="max-height: 350px">
            @for (pkg of trainingPackages; track pkg.package_id) {
              <div class="d-flex align-items-center py-4 border-bottom border-gray-200">
                <div class="symbol symbol-35px symbol-circle me-4 flex-shrink-0">
                  <span class="symbol-label bg-light-primary">
                    <i class="fa fa-box-open text-primary fs-6"></i>
                  </span>
                </div>
                <div class="flex-grow-1 me-3" style="min-width: 0;">
                  <span class="text-gray-800 fw-bold fs-6 d-block text-truncate">{{ pkg.package_name }}</span>
                  <span class="text-gray-500 fw-semibold fs-7">{{ (pkg.price_cents / 100) | number:'1.0-0' }} {{ pkg.currency || getDefaultCurrency() }} {{ 'manageEvent.overview.perPackage' | translate }}</span>
                </div>
                <div class="text-end flex-shrink-0" style="min-width: 90px;">
                  <span class="badge badge-light-primary fs-7 fw-bold">{{ pkg.current_registrations || 0 }} {{ 'manageEvent.overview.sold' | translate }}</span>
                </div>
                <div class="text-end flex-shrink-0" style="min-width: 100px;">
                  <span class="text-gray-800 fw-bold">{{ getPackageNetRevenue(pkg) | number:'1.0-0' }} {{ pkg.currency || getDefaultCurrency() }}</span>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  } @else if (!isSocialEvent) {
    <!-- Class Registrations (for competition events only, not social events) -->
    <div class="col-xl-6 mb-xl-10">
      <div class="card card-flush h-lg-100">
        <div class="card-header flex-nowrap pt-5">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label fw-bold text-gray-900">{{ 'manageEvent.overview.classRegistrations' | translate }}</span>
            <span class="text-gray-500 pt-2 fw-semibold fs-6">{{ getTotalClassRegistrations() }} {{ 'manageEvent.overview.totalRegistrationsAcross' | translate }} {{ eventClasses.length }} {{ 'manageEvent.overview.classesLabel' | translate }}</span>
          </h3>
        </div>
        <div class="card-body pt-5">
          @if (eventClasses.length === 0) {
            <div class="text-center py-10">
              <i class="fa fa-trophy text-gray-300 fs-3x mb-5"></i>
              <p class="text-gray-500 fs-6">{{ 'manageEvent.overview.noClassesCreated' | translate }}</p>
            </div>
          } @else {
            <div class="hover-scroll-overlay-y pe-6 me-n6" style="max-height: 350px">
              @for (eventClass of eventClasses; track eventClass.event_class_id) {
                <div class="d-flex align-items-center py-4 border-bottom border-gray-200">
                  <div class="symbol symbol-35px symbol-circle me-4 flex-shrink-0">
                    <span class="symbol-label bg-light-info">
                      <i class="fa fa-horse text-info fs-6"></i>
                    </span>
                  </div>
                  <div class="flex-grow-1 me-3" style="min-width: 0;">
                    <span class="text-gray-800 fw-bold fs-6 d-block text-truncate">{{ eventClass.class_name }}</span>
                    <span class="text-gray-500 fw-semibold fs-7">{{ eventClass.price | number:'1.0-0' }} {{ eventClass.price_currency || getDefaultCurrency() }} {{ 'manageEvent.overview.perEntry' | translate }}</span>
                  </div>
                  <div class="text-end flex-shrink-0" style="min-width: 80px;">
                    <span class="badge badge-light-info fs-7 fw-bold">{{ eventClass.event_class_registrations?.length || 0 }} {{ 'manageEvent.overview.entries' | translate }}</span>
                  </div>
                  <div class="text-end flex-shrink-0" style="min-width: 100px;">
                    <span class="text-gray-800 fw-bold">{{ getClassNetRevenue(eventClass) | number:'1.0-0' }} {{ eventClass.price_currency || getDefaultCurrency() }}</span>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }

  <!-- Service Registrations Detail -->
  <div class="col-xl-6 mb-5 mb-xl-10">
    <div class="card card-flush h-lg-100">
      <div class="card-header flex-nowrap pt-5">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label fw-bold text-gray-900">{{ 'manageEvent.overview.serviceBookings' | translate }}</span>
          <span class="text-gray-500 pt-2 fw-semibold fs-6">{{ getTotalServiceRegistrations() }} {{ 'manageEvent.overview.totalBookingsAcross' | translate }} {{ eventServices.length }} {{ 'manageEvent.overview.servicesLabel' | translate }}</span>
        </h3>
      </div>
      <div class="card-body pt-5">
        @if (eventServices.length === 0) {
          <div class="text-center py-10">
            <i class="fa fa-concierge-bell text-gray-300 fs-3x mb-5"></i>
            <p class="text-gray-500 fs-6">{{ 'manageEvent.overview.noServicesCreated' | translate }}</p>
          </div>
        } @else {
          <div class="hover-scroll-overlay-y pe-6 me-n6" style="max-height: 350px">
            @for (service of eventServices; track service.event_service_id) {
              <div class="d-flex align-items-center py-4 border-bottom border-gray-200">
                <div class="symbol symbol-35px symbol-circle me-4 flex-shrink-0">
                  <span class="symbol-label bg-light-danger">
                    <i class="fa fa-box text-danger fs-6"></i>
                  </span>
                </div>
                <div class="flex-grow-1 me-3" style="min-width: 0;">
                  <span class="text-gray-800 fw-bold fs-6 d-block text-truncate">{{ service.event_service_name }}</span>
                  <span class="text-gray-500 fw-semibold fs-7">{{ service.price | number:'1.0-0' }} {{ service.price_currency || getDefaultCurrency() }} {{ 'manageEvent.overview.perBooking' | translate }}</span>
                </div>
                <div class="text-end flex-shrink-0" style="min-width: 90px;">
                  <span class="badge badge-light-danger fs-7 fw-bold">{{ getServiceRegistrationCount(service) }} {{ 'manageEvent.overview.bookings' | translate }}</span>
                </div>
                <div class="text-end flex-shrink-0" style="min-width: 100px;">
                  <span class="text-gray-800 fw-bold">{{ getServiceNetRevenue(service) | number:'1.0-0' }} {{ service.price_currency || getDefaultCurrency() }}</span>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
